import React from 'react'
import Box from '../components/Box'

export default function Section3() {
    return (
        <div className="section">
            <h2>Section III: Categories</h2>
            <Box sectionData={'start'} title={'Add Category'} body={`Note:  
            • Categories  are  required  for  any  class  configured  with  a  weighted  grade  scale.   Assignments 
            cannot be entered until categories have been configured and the total weight is exactly 100%. 
            • Categories are supported but optional for classes configured with a standard grade scale. 
            1. Tap the manage button and select “Categories” from the menu. 
            2. Tap the “+” button to add a category. 
            3. Enter the name and (optional) weight of the category and tap “Save”. 
            4. Repeat (b) – (c) for each category. 
            5. Tap “Done”.`} />


            <Box title={'Edit Category'} body={`1. Tap the “Manage” button and select “Categories” from the menu. 
            2. Tap the category to be edited. 
            3. Make the desired changes and tap “Save”. 
            4. Tap “Done”.`} />

            <div className="box-container">
                <div className="heading">Delete Category</div>
                <div className="body">
                    <p>Note:</p>
                    <p>• Deleting a category (as opposed to editing it) will delete all assignments currently associated with the category being deleted.</p>
                    <p>• This cannot be undone.</p>
                    <br/>
                    <p>1. Tap the “Manage” button and select “Categories” from the menu.</p>
                    <p>2. Tap the "Edit" button.</p>
                    <p>3. Tap the “-“ button on the category to be deleted.</p>
                    <p>4. Confirm by tapping the “Delete” button.</p>
                    <p>5. Confirm again by selecting ‘Delete Category’.</p>
                </div>
            </div>

            <Box sectionData={'end'} title={'Copy Categories'} body={`1. Select the destination class. 
            2. Tap “Manage”. 
            3. Tap “Categories”. 
            4. Tap “Copy”. 
            5. Select the source class. 
            6. Tap “Copy”.`} />
        </div>
    )
}